// AUTO-GENERATED by scripts/build-release-notes.mjs from release-notes/*.md.
// Do not edit by hand; this file is gitignored and rebuilt on every addon build.
export default {
  "notes": [
    {
      "id": "0.0.0-des567.0-fix-menu-item-click-target-for-highlighted-search-matches",
      "version": "0.0.0-des567.0",
      "title": "Fix menu item click target for highlighted search matches",
      "date": "2026-08-17",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-567/output-value-is-empty-when-creating-modifier-rules",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Menu::Item",
        "Spds::Input::Search",
        "Spds::Input::Dropdown::List"
      ],
      "services": [],
      "body": "Menu item click handlers now always receive the menu item itself as `event.target`, even when the click lands on content nested inside the item.\n\nFiltering a search or dropdown list wraps the matching portion of each option in a `<strong>` element to highlight it. Clicking directly on that bolded text made the `<strong>` the event target, so handlers reading `event.target.dataset.value` or `event.target.getAttribute('aria-selected')` — the documented way to identify the chosen option — got `undefined`. Consumers saw a selection that looked correct in the UI but carried no value, such as a claim edit rule saving with a blank modifier.\n\n`Spds::Core::Menu::Item` now forwards a proxy of the native click event that reports the item as `target`. Everything else on the event is untouched, so `currentTarget`, `preventDefault()`, and modifier keys behave as before, and consumers reading either `target` or `currentTarget` need no changes. Because the fix lives on the shared menu item, it also covers the select and filter menus and the dropdown and split action buttons."
    },
    {
      "id": "9.6.0-configurable-time-picker-minute-options",
      "version": "9.6.0",
      "title": "Configurable time picker minute options",
      "date": "2026-08-13",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/ENG-704/add-configurable-sub-hour-time-granularity-to-the-calendar",
      "tags": [],
      "components": [
        "Spds::Input::TimePicker"
      ],
      "services": [],
      "body": "`Spds::Input::TimePicker` accepts `@minuteOptions` so callers can offer minute increments other\nthan the default 15-minute grid (`['00', '15', '30', '45']`). Pass an array of two-digit minute\nstrings:\n\n```handlebars\n<Spds::Input::TimePicker\n  @minuteOptions={{array \"00\" \"05\" \"10\" \"15\" \"20\" \"25\" \"30\" \"35\" \"40\" \"45\" \"50\" \"55\"}}\n  @onSetTime={{this.setTime}}\n/>\n```\n\nThe default is unchanged. The lowercase `am`/`pm` time format also includes a space after the\nnumeral (`2:15 pm`) to match design-system date-and-time guidelines."
    },
    {
      "id": "9.5.0-route-aware-buttons",
      "version": "9.5.0",
      "title": "Route-aware buttons",
      "date": "2026-08-07",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-550",
      "tags": [
        "a11y",
        "routing"
      ],
      "components": [
        "Spds::Core::Button",
        "Spds::Action::Button::Variable"
      ],
      "services": [],
      "body": "Every SPDS button variant can now act as an Ember `LinkTo`. Provide `@route` and the button\nrenders as an `<a>` with a real `href`, keeping its variant styling:\n\n```handlebars\n<Spds::Action::Button::Primary @route=\"clients.show\" @model={{this.client}}>\n  View client\n</Spds::Action::Button::Primary>\n```\n\nThis replaces the two patterns teams reach for today: a `<LinkTo>` with `class=\"button primary\"`\nhand-copied from the design system, and `<Spds::Action::Button::Primary @tag=\"a\" href=...>`, which\nproduces a link with no routing behavior and the wrong `role`.\n\nAvailable on `Primary`, `Secondary`, `Tertiary`, `Ghost`, `Negative`, `Destructive`,\n`Promotional`, `Link`, and the `Agent::*` variants — every component extending\n`Spds::Core::Button`. Button types that shouldn't navigate (`Filter::*`, `Split::*`,\n`Dropdown::*`, `Close`, `Copy`) extend `Spds::Core::Base` instead and are unaffected.\n\n`Variable` also accepts the routing arguments and forwards them to whichever type it renders, since\nevery type it can delegate to is route-aware:\n\n```handlebars\n<Spds::Action::Button::Variable\n  @buttonType={{if this.isCurrent \"primary\" \"ghost\"}}\n  @route=\"styleguide\"\n  @query={{hash s=\"DS Actions\"}}\n/>\n```\n\nArguments:\n\n* `route` (string): target route name. Providing this is what turns the button into a link. An empty\n  string counts as absent, matching how every other SPDS string argument reads it.\n* `model` / `models`: dynamic segment values. Pass one or the other, not both.\n* `query` (object): query parameters. Passing `query` without a route — or alongside an empty one —\n  links to the current route.\n* `replace` (boolean): replace the current history entry instead of adding one.\n* `activeWhen` (array, string, or boolean): route name(s) that mark the link as active. An array of\n  route names is the preferred form; a space-separated string and a boolean that forces the state on\n  or off are both still accepted.\n* `activeClass` (string): class applied while the target route is active (default:\n  `spds-link-active`).\n\n`model` and `activeWhen` each accept several data types, so they carry a new `MULTIPLE` metadata\ntype. It renders as a `Multiple` tag in the styleguide API table and is deliberately excluded from\nthe validatable types: no assertion spans several types, and typing these narrowly would reject\nvalid values. Any component argument that legitimately accepts more than one type can use it, but\nnote that a `MULTIPLE` argument is skipped during validation entirely, so it cannot carry `forbids`\nor `requires` rules.\n\nBecause `href` is a real generated URL, browser link affordances work as users expect:\ncmd/ctrl-click opens a new tab, shift-click a new window, middle-click a background tab, and\n`target=\"_blank\"` opens a new tab. Pass `rel` explicitly alongside `target` — `target` is an HTML\nattribute rather than an argument, so the component can't inspect it to add\n`rel=\"noopener noreferrer\"` for you.\n\n`href` itself is the one attribute the component keeps for itself. A splatted `href` cannot override\nthe generated URL, and it cannot reintroduce one on a link that deliberately has none — so migrating\nan existing `@tag=\"a\" href={{...}}` button to `@route` can't leave a stale URL silently winning.\n\nRouting behavior is delegated to `LinkTo` rather than reimplemented, with two deliberate\ndifferences:\n\n* **No `role=\"button\"` in link mode.** Announcing an anchor as a button breaks link semantics and\n  Enter/Space expectations.\n* **`@disabled` renders `aria-disabled` with no `href`.** `LinkTo` checks for modified clicks and\n  `target` *before* it checks its own disabled state, so a disabled `LinkTo` still navigates on\n  cmd-click or with `target=\"_blank\"`. An anchor without an `href` is neither focusable nor exposed\n  as a link, which is the correct disabled semantic.\n\nOne authoring note: a nullish `@model` renders a non-navigating element and logs a warning rather\nthan the silent, clickable-but-dead `href=\"#\"` that `LinkTo` produces on its own. Guard the\nargument or omit `@route` until the model has loaded."
    },
    {
      "id": "9.4.0-standardize-animated-argument-for-ds-components",
      "version": "9.4.0",
      "title": "Standardize animated argument for DS components",
      "date": "2026-08-10",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-549",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Menu::Filterable",
        "Spds::Menu::Select",
        "Spds::Menu::Multiselect",
        "Spds::Action::Button::Dropdown",
        "Spds::Action::Button::Split",
        "Spds::Action::Button::Filter::Base",
        "Spds::Action::Button::Filter::Menu",
        "Spds::Action::Button::Filter::SingleSelect",
        "Spds::Action::Button::Filter::Multiselect",
        "Spds::Input::Search",
        "Spds::Input::Dropdown::List",
        "Spds::Feedback::Tooltip",
        "Spds::Feedback::FeatureBanner",
        "Spds::Feedback::AlertBanner::Message",
        "Spds::Indicator::LoadingOverlay"
      ],
      "services": [],
      "body": "Most animated DS components already exposed an `@animated` argument to toggle their\nanimations on and off, but several animated components did not. This release standardizes\n`@animated` across the remaining components so their animations can be disabled — useful for\nreduced-motion contexts and for stabilizing visual (Percy) snapshots.\n\nEvery listed component now accepts `@animated` (defaulting to `true`, so existing behavior is\nunchanged). Passing `@animated={{false}}` disables the animation.\n\n### Menu-composing components\n\nThe dropdown, split, and filter buttons, the search and dropdown-list inputs, and the\nunderlying `Spds::Menu::*` components now accept `@animated` and forward it down to the menu\nthey render. Previously the menu's open/close fade was hardcoded on for these consumers.\n\n### Fade / expand feedback components\n\n`Spds::Feedback::Tooltip`, `Spds::Feedback::FeatureBanner`,\n`Spds::Feedback::AlertBanner::Message`, and `Spds::Indicator::LoadingOverlay` gate their\nfade/expand transitions and keyframe animations behind `@animated`. When disabled, they also\nskip the exit-animation wait so show/hide is immediate. Alert banners dispatched through the\n`alertManager` service can set `animated` on the broadcast payload to control this per banner.\n\nNote: on `Spds::Feedback::FeatureBanner`, `@animated` is complementary to `@animateIn`.\n`@animateIn` controls only the entrance animation, while `@animated={{false}}` disables all\nanimation on the banner."
    },
    {
      "id": "9.3.0-add-character-limit-support-to-search-inputs",
      "version": "9.3.0",
      "title": "Add character limit support to search inputs",
      "date": "2026-07-31",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-513",
      "tags": [
        "DS Maintenance",
        "Incremental feature enhancement"
      ],
      "components": [
        "Spds::Input::Search",
        "Spds::Input::Search::Field",
        "Spds::Input::Search::Trigger",
        "Spds::Menu::Search",
        "Spds::Menu::Filterable",
        "Spds::Core::CharacterCounter",
        "Spds::Core::Input"
      ],
      "services": [],
      "body": "The search input family now supports a character limit, mirroring the existing behavior on `Spds::Input::Text`. Pass `@charLimit` and the field automatically renders a character counter and hard-caps typing at the limit via the native input `maxlength`. Consumers that want the cap without the visible counter can opt out with `@hideCharacterCounter`.\n\n## Why\n\n`ember-messaging-client` needs a bounded search/filter input, and the character-limit affordance already existed on the text input. This surfaces the same capability across the search components rather than reimplementing it per consumer.\n\n## Usage\n\n`@charLimit` is available on the search components and, when set to a positive number, both renders the counter beneath the field and enforces the cap:\n\n```hbs\n<Spds::Input::Search @charLimit={{50}} @value={{this.query}} @onChange={{this.onChange}} as |search|>\n  <search.trigger />\n  <search.menu as |menu|>\n    {{#each this.items as |item|}}\n      <menu.item @value={{item.value}}>{{item.label}}</menu.item>\n    {{/each}}\n  </search.menu>\n</Spds::Input::Search>\n```\n\n| Component | Arguments |\n| --- | --- |\n| `Spds::Input::Search` | `@charLimit`, `@hideCharacterCounter` |\n| `Spds::Input::Search::Field` | `@charLimit`, `@hideCharacterCounter` |\n| `Spds::Input::Search::Trigger` | `@charLimit`, `@hideCharacterCounter` |\n| `Spds::Menu::Search` | `@charLimit`, `@hideCharacterCounter` |\n| `Spds::Menu::Filterable` | `@searchCharLimit`, `@searchHideCharacterCounter` (forwarded to its in-menu search) |\n\nA `@charLimit` of `0` (the default) is treated as \"no limit\": no counter renders and no `maxlength` is applied. `Spds::Core::Input` now only emits `maxlength` when the value is greater than `0`, guarding against a `maxlength=\"0\"` that would otherwise silently block all typing.\n\n`@hideCharacterCounter` (default `false`) suppresses the counter while leaving the limit in force, for fields that are tight on vertical space or that surface the remaining-character affordance elsewhere. The cap is enforced whether or not the counter is visible, and the argument is inert on its own — with no positive `@charLimit` there is no counter to hide.\n\nBoth arguments are defined once in the `inputForm` shared argument collection (`utils/spds/metadata/shared-arguments`) and picked into each component, so their types and descriptions stay consistent across the API. `Spds::Menu::Filterable` picks both under a rename so its in-menu search arguments stay namespaced.\n\n## Internal changes\n\n- **Character counter typography.** `Spds::Core::CharacterCounter` now renders through `Spds::Typography::Caption` instead of `Spds::Core::Container`, aligning it with the typography system introduced in 9.0.0.\n- **`over` → `error` (breaking for consumers keying on the class).** The counter's over-limit state now uses the shared `error` state hoisted onto `Spds::Typography::Base` in 9.0.0, replacing the bespoke `over` class. The `data-test-spds-character-counter` hook is unchanged, but any test or style targeting `.over` on the character counter must switch to `.error`.\n- **Search field structure / menu anchoring.** `Spds::Input::Search::Field` renders the input row and the counter row as sibling roots rather than nesting them in a wrapping column. This keeps the input row a direct child of the consumer's container so menus continue to anchor and position correctly. `Spds::Menu::Search` now stacks its field in a column to match."
    },
    {
      "id": "9.2.0-introduce-skeleton-loading-component",
      "version": "9.2.0",
      "title": "Introduce skeleton loading component",
      "date": "2026-08-03",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-538/introduce-skeleton-loading-component",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Indicator::Skeleton"
      ],
      "services": [],
      "body": "Introduces `Spds::Indicator::Skeleton`, a DS-compliant placeholder that mimics\nthe shape of content while it loads. It promotes the styleguide-internal\n`placeholder-content` helper into a first-class SPDS component and adds an\non-by-default animation.\n\n## Usage\n\n```handlebars\n<Spds::Indicator::Skeleton @rowCount={{5}} />\n```\n\nThe component renders a header bar plus `@rowCount` body lines (default `3`).\n\n## Animation\n\n`@animated` (default `true`) is a single switch that gates BOTH the shimmer and\nthe fade transition:\n\n* **Default** (`@animated={{true}}`): the placeholder shimmers while visible and\n  fades in on appear. Pass `@when={{this.isLoading}}` to keep it mounted and fade\n  it out before it is removed from the DOM (mirrors `Spds::Indicator::LoadingOverlay`).\n* **Off** (`@animated={{false}}`): fully static with no shimmer and no fade; it\n  mounts and unmounts instantly.\n\nThe shimmer and fade both respect `prefers-reduced-motion`.\n\n## Notes\n\n* The body lines are marked `aria-hidden=\"true\"`.\n* `@rowCount` is a number argument; pass numeric values (e.g. `@rowCount={{5}}`)."
    },
    {
      "id": "9.1.0-introduce-tooltip-modifier",
      "version": "9.1.0",
      "title": "Introduce tooltip modifier",
      "date": "2026-08-03",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-545",
      "tags": [
        "DS Modifier"
      ],
      "components": [],
      "services": [
        "Tooltip"
      ],
      "body": "A new `{{spds-tooltip}}` modifier attaches a DS tooltip to any HTML element or Ember\ncomponent, without extending `Spds::Core::Base`, injecting the `spds/tooltip` service, or\nrendering `Spds::Feedback::Tooltip` and threading an `@anchorElement` reference. Apply the\nmodifier and provide the text:\n\n```handlebars\n<button type=\"button\" {{spds-tooltip content=\"Delete this item\"}}>\n  <Icon @name=\"trash\" />\n</button>\n```\n\nThe tooltip appears on hover and keyboard focus, and non-interactive anchors (e.g. a\n`<div>`) are made keyboard focusable automatically.\n\nArguments:\n\n* `content` (string, required): text displayed in the tooltip body.\n* `title` (string, optional): bold title displayed above the body text.\n* `placement` (string, optional): position relative to the anchor (default: `top-middle`; see the style guide for all values).\n* `offset` (string, optional): gap between the tooltip and its anchor (default: `8px`).\n\nThe modifier is a thin wrapper over the existing `spds/tooltip` service and\n`Spds::Feedback::Tooltip::Container`, so it inherits the same content standards (text\nonly), accessibility (`aria-describedby`, hover/focus, Escape dismissal), and automatic\nviewport-edge repositioning as the tooltip component."
    },
    {
      "id": "9.0.0-move-label-and-helper-text-into-typography",
      "version": "9.0.0",
      "title": "Move label and helper text into typography",
      "date": "2026-07-30",
      "type": "breaking",
      "issue": "https://linear.app/simplepractice/issue/DES-516",
      "tags": [
        "DS Component Creation",
        "a11y"
      ],
      "components": [
        "Spds::Typography::Base",
        "Spds::Typography::Label",
        "Spds::Typography::HelperText"
      ],
      "services": [],
      "body": "`Spds::Core::Label` and `Spds::Core::HelperText` now live in the `Spds::Typography`\ncollection as `Spds::Typography::Label` and `Spds::Typography::HelperText`. Update\ninvocations (`<Spds::Core::Label>` → `<Spds::Typography::Label>`) and imports\n(`ember-simplepractice/components/spds/core/label` → `.../typography/label`).\n\nBoth components now extend `Spds::Typography::Base`, so they gain the shared typography\nsurface (`@strong`, `@content`, `size` class mapping) and drop the tooltip args they\npreviously inherited from `Spds::Core::Base` (they are not tooltip anchors).\n\nThe reusable `@srOnly` (visually-hidden) and `@error` state capabilities have been hoisted\nonto `Spds::Typography::Base`, so **every** typography component — `Display`, `Heading`,\n`Body`, `Caption`, `Subtitle`, plus `Label` and `HelperText` — now supports `@srOnly` and\n`@error`.\n\nThe components keep their own templates, so the `data-test-spds-label` and\n`data-test-spds-helper-text` selectors and the emitted CSS classes are unchanged. Note that\nthe **value** of `data-test-spds-label` changes from `Spds::Core::Label` to\n`Spds::Typography::Label`; update any selector keyed on that value."
    },
    {
      "id": "8.13.0-introduce-typography-components",
      "version": "8.13.0",
      "title": "Introduce typography components",
      "date": "2026-07-13",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-503",
      "tags": [
        "DS Component Creation"
      ],
      "components": [],
      "services": [],
      "body": "Adds an `Spds::Typography` component collection to formalize DS typography patterns with reusable components.\n\nEach type style/size is its own component that composes `Spds::Core::Container`, renders a\nsensible default HTML tag, and sizes itself with the shared `$font-size-normal-*` rem\nvariables while pulling weight and line-height from `--token-font-*` custom properties.\n\n- **Display** — `Display::XLarge`, `Display::Large` (default `p`).\n- **Heading** — `Heading::XLarge` through `Heading::XXSmall` (default `h1`–`h6`, semibold).\n- **Body** — `Body::XLarge` through `Body::Small` (default `p`); pass `@strong` for semibold.\n- **Caption** — `Caption`, `Caption::Small` (default `span`); pass `@strong` for semibold.\n- **Subtitle** — `Subtitle` (default `span`, semibold, uppercase).\n\nThe rendered element can be overridden per usage via `@tag`, decoupling visual size from\nsemantic markup, and text can be supplied via block content or the `@content` argument.\n\nShips the normal (desktop/large-tablet) scale; the compact/mobile scale and responsive\nswitching are a planned follow-up."
    },
    {
      "id": "8.12.0-remove-deprecated-local-toast-methods",
      "version": "8.12.0",
      "title": "Remove deprecated local toast methods",
      "date": "2026-07-17",
      "type": "cleanup",
      "issue": "https://linear.app/simplepractice/issue/DES-522/remove-deprecated-local-toast-methods-from-ds-service",
      "tags": [],
      "components": [],
      "services": [
        "Spds::Toast"
      ],
      "body": "The `spds/toast` service no longer exposes the deprecated `local*` family of methods (`localError`, `localSuccess`, `localSystem`, and `fileUploadLocalToast`). These forwarded to their global counterparts and emitted a deprecation warning under the `spds.toast.local-methods` id.\n\nToasts render as `popover=\"manual\"` elements in the browser top layer via `Spds::Feedback::Toast::Container`, so they already stack above modals and other layered UI without a nested local container. A separate local toast API was therefore unnecessary. All consumer call sites were migrated in DES-425, so the methods are now removed along with their tests, style guide documentation, and the `spds.toast.local-methods` deprecation handling.\n\nUse the global methods instead: `error`, `success`, `system`, and `fileUploadToast`."
    },
    {
      "id": "8.11.0-introduce-multiselect-filter-button",
      "version": "8.11.0",
      "title": "Introduce multiselect filter button",
      "date": "2026-07-13",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/INS-1801",
      "tags": [
        "filter",
        "multiselect",
        "menu",
        "button"
      ],
      "components": [
        "Spds::Action::Button::Filter::Multiselect"
      ],
      "services": [],
      "body": "`Spds::Action::Button::Filter::Multiselect` is a filter button that opens a\n`Spds::Menu::Multiselect` dropdown, complementing the existing quick and single-select filter\nbuttons.\n\nThe trigger content is supplied through the `:label` block and the menu options through the\n`:menu` block, which yields the `item`, `expandableItem`, and `noResults` components from the\nunderlying multiselect menu. The button anchors the menu to itself, toggles it open on click, and\ncloses it on an outside click.\n\n- **Filtered state**: the `filtered` styling that marks an active filter defaults to whether a\n  selection exists and can be overridden with `@filtered`.\n- **Selection reporting**: `@onChange` receives `{ values }` whenever the selection changes.\n- **Menu configuration**: search (`@searchable`, `@searchPlaceholder`, `@searchThreshold`),\n  select-all (`@selectAllLabel`, `@selectAllMin`), the footer (`@onApply`, `@onClearAll`,\n  `@showClearAll`), `@subtitle`, and `@selected` are forwarded to the multiselect menu. Apply also\n  closes the menu.\n- **Trigger**: `@buttonType` (defaults to secondary), `@disabled`, `@fitContent`, and `@autofocus`\n  configure the button, and `@onClick` fires on trigger clicks."
    },
    {
      "id": "8.11.0-update-open-modals-through-the-modal-service",
      "version": "8.11.0",
      "title": "Update open modals through the modal service",
      "date": "2026-07-13",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-500/add-ability-to-update-modals-through-the-service",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Modal::Container::Global"
      ],
      "services": [
        "SpdsModal",
        "AlertManager"
      ],
      "body": "The `spds/modal` service now exposes an `update(modalId, params)` method for\npatching a modal that is already open. Rather than closing and re-opening a\nmodal to change its content, you can merge new params into the existing modal\nin place:\n\n```js\n@service('spds/moda') modal;\n\n...\n\nlet modalId = await this.modal.create({\n  modalComponent: 'transactional',\n  title: 'Saving…',\n  bodyText: 'Hang tight while we save your changes.',\n  primaryBtnText: 'OK',\n});\n\n// later, once the work finishes\nawait this.modal.update(modalId, {\n  title: 'Saved',\n  bodyText: 'Your changes were saved successfully.',\n});\n```\n\n`update` broadcasts the `update` variant of the modal event, which\n`Spds::Modal::Container::Global` handles by merging the supplied params over the\nmatching modal's existing configuration. Only the keys you pass are changed —\nuntouched params are preserved — and an unknown `modalId` is a no-op.\n\nThis brings the design system service to parity with the update behavior that\npreviously only existed on the deprecated `global-modal-container` service,\nclearing the way to fully retire that older service."
    },
    {
      "id": "8.11.0-consolidate-menus-and-restore-core-purity",
      "version": "8.11.0",
      "title": "Consolidate menus and restore core purity",
      "date": "2026-07-06",
      "type": "enhancement",
      "tags": [
        "menu",
        "multiselect",
        "architecture"
      ],
      "components": [],
      "services": [],
      "body": "The menu components have been reorganized so that `core` stays true to its name, the menu shell\nis decomposed into composable regions, and the two near-duplicate multiselect menus have been\nunified into one.\n\n### Core namespace purity\n\n`Spds::Core::Menu::Base` is now a minimal, dependency-free menu shell: it handles positioning and\nyields its content regions, nothing more. The in-menu search UI and the multiselect clear-filter\ncontrol have moved out of `core` (they depend on non-core components):\n\n- `Spds::Core::Menu::Search` → `Spds::Menu::Search`\n- `Spds::Core::Menu::Search::Input` → `Spds::Input::Search::Field`\n- `Spds::Core::MultiselectClearFilter` → `Spds::Input::MultiselectClearFilter`\n\nCSS hooks and `data-test-*` attributes are preserved, so downstream styling and tests are\nunaffected.\n\n### Composable menu regions\n\nRather than hard-coding its internal layout, `Spds::Core::Menu::Base` now yields three contextual\nregions so callers compose only what they need:\n\n- `Header` — a new `Spds::Core::Menu::Header`, pinned above the list.\n- `Body` — the scrollable option list plus the optional no-results state.\n- `Footer` — a new `Spds::Core::Menu::Footer`, pinned below the list, outside the scroll region.\n\nThe list body was extracted into a shared list component so that `Spds::Core::Menu::Base` and\n`Spds::Menu::Filterable` render identical list markup without duplication. The no-results state\n(`@noItemsDisplayed`, `@noResultsText`) continues to render in place of the list when empty.\n\n### Filterable menu\n\nSearch-enabled menu behavior now lives in the new `Spds::Menu::Filterable`, which extends\n`Spds::Core::Menu::Base` and adds the in-menu search field (`@searchable`, `@searchPlaceholder`,\n`@searchThreshold`). It surfaces the `:header`, `:body`, and `:footer` regions as named blocks, and\nthe field stays responsive while filtering is debounced (typing updates the input immediately;\nthe filter is applied once input settles). Single-select menus that expect built-in search now use\nthis component.\n\n### Unified automatic filtering\n\n`Spds::Menu::Filterable` is now the single source of truth for basic text-match filtering. The same\nmechanism backs both the in-menu search field and an external search term (`@searchValue`), so a\nterm hides non-matching options and highlights matches once, in one place, rather than each input\nre-implementing it:\n\n- automatic filtering is on by default (`@autoFilter`, default `true`);\n- an external term is applied immediately (the parent already controls typing cadence), while\n  in-menu typing debounces;\n- when only the item set changes while a filter is active (e.g. an async list gaining or losing\n  rows), the filter re-applies synchronously so filtered rows never flash back to the full list;\n- clearing the search, or closing the menu, reveals **only** the items the filter itself hid — a\n  consumer's own declarative `hidden` state is left untouched.\n\nCustom or async filtering opts out with `@autoFilter={{false}}` (or a custom `@filter`): the parent\nowns hiding, and each item highlights its own matches, so bolding still works. Highlighting is never\napplied twice — when `@autoFilter` is on, the menu highlights; when it is off, the item does.\n\n### Unified multiselect menu\n\n`Spds::Menu::Multiselect` replaces the two internal multiselect menus previously used by\n`Spds::Input::Dropdown::List` and `Spds::Input::Search`. It composes `Spds::Menu::Filterable`\nwith a checkbox group and adds:\n\n- an automatic \"Select all\" option gated by a configurable threshold,\n- an optional `expandableItem` — the new `Spds::Menu::Multiselect::ExpandableItem`, a checkbox with\n  a collapsible accordion of additional content (descriptive text, nested options, or any markup)\n  that auto-expands whenever that content matches the active search (auto-expansion always tracks the\n  search term; match highlighting follows `@autoFilter`). Manual toggles and search-driven expansion\n  share a single open state, and expanding scrolls the section's content into view so an item near\n  the bottom of the list is not hidden below the fold,\n- an opt-in footer with **Apply** and **Clear all** actions,\n- additive selection hooks (`@onSelectAll`, `@onClearAll`) that are independent of the\n  `@selectAll` behavior override.\n\n### Unified single-select menu\n\n`Spds::Menu::Select` replaces the two internal single-select menus previously used by\n`Spds::Input::Dropdown::List` and `Spds::Input::Search`, mirroring the multiselect merge. It\ncomposes `Spds::Menu::Filterable` and switches search source based on `@searchValue`:\n\n- without `@searchValue` (dropdown usage) it uses the built-in in-menu search\n  (`@searchable`, `@searchPlaceholder`, `@searchThreshold`);\n- with `@searchValue` (search-input usage) the parent owns filtering, the in-menu search is\n  suppressed, and matches are highlighted.\n\nThe mode-appropriate container class (`spds-input-dropdown-list-menu` / `spds-input-search-menu`),\nitem variant class (`spds-input-dropdown-list-item` / `spds-input-search-menu-item`), and the\n`data-test-*` hooks for both consumers are preserved, so downstream styling and tests are\nunaffected. As part of this, `Spds::Menu::Filterable` now honors `@noItemsDisplayed` when deciding\nto show the no-results state (previously only its own internal search count was considered).\n\n### Consumers migrated to the shared primitives\n\nThe menu-based components were re-pointed at the reorganized shell: the dropdown, filter, and split\naction-button menus render through `Spds::Menu::Filterable` and the new `:header`/`:body`/`:footer`\nregions, and the `Spds::Input::Dropdown::List` / `Spds::Input::Search` inputs now render through the\nunified `Spds::Menu::Select`. The filter action-button menu was also fixed to yield its options into\nthe `:body` region (it previously yielded into the default block, so its options did not render).\n`Spds::Input::Group::Checkbox` and the shared `menu-filter` utility were updated to back the unified\nmultiselect. These are internal composition changes; the public APIs of `Spds::Input::Dropdown::List`\nand `Spds::Input::Search` are unchanged."
    },
    {
      "id": "8.10.1-cleanup-ds-sass-variables-in-favor-of-custom-properties",
      "version": "8.10.1",
      "title": "Cleanup DS SASS variables in favor of custom properties",
      "date": "2026-06-25",
      "type": "cleanup",
      "issue": "https://linear.app/simplepractice/issue/DES-497/cleanup-ds-sass-variables-in-favor-of-custom-properties",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Container::Accordion",
        "Spds::Core::Menu",
        "Spds::Input::Dropdown",
        "Spds::Input::TimePicker"
      ],
      "services": [],
      "body": "Replaces local SASS variables in SPDS component stylesheets with CSS custom properties. These variables were mostly used to compute values local to a given stylesheet (animation timings, spacing, and rhythm-based sizing), which tied those values to compile time. Moving them to custom properties lets the same values be recomputed at runtime, giving us greater flexibility for component presentation with no change to existing behavior.\n\nThe remaining SASS variable usage across SPDS components is now limited to shared font tokens (`$font-size-*` and `$font-family-percy`)."
    },
    {
      "id": "8.10.0-unify-ds-keyboard-navigation",
      "version": "8.10.0",
      "title": "Unify DS keyboard navigation",
      "date": "2026-06-25",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-486/unify-ds-keyboard-navigation",
      "tags": [
        "a11y",
        "keyboard navigation",
        "DS Maintenance",
        "internal"
      ],
      "components": [
        "Spds::Core::KeyboardNavigable",
        "Spds::Core::SelectableMenu",
        "Spds::Input::MenuParent",
        "Spds::Input::Search",
        "Spds::Input::Search::Trigger",
        "Spds::Input::Dropdown::List",
        "Spds::Action::Button::Filter::SingleSelect"
      ],
      "services": [],
      "body": "The design system previously carried two separate keyboard-navigation implementations — one for inputs (search/dropdown) and one for filter menu buttons. Maintaining both went against our principle of reuse over repetition, so they have been consolidated into a single, shared navigation engine.\n\n### What changed\n\nTwo abstract `Spds::Core` base components now provide the navigation behavior that consumers previously duplicated:\n\n- **`Spds::Core::KeyboardNavigable`** — a reusable arrow-key navigation engine for any component that exposes a list of focusable options behind an openable menu. It handles open/close on `ArrowUp`/`ArrowDown`/`Enter`, vertical movement (including `Tab`/`Shift+Tab`), optional horizontal traversal of auxiliary controls, `Enter` selection, and `Escape` to close. Active option focus is tracked via the `active` class and `element.focus()`, and the engine operates on a consumer-supplied `navigableOptions` list rather than querying the DOM.\n- **`Spds::Core::SelectableMenu`** — layers single-value selection on top of the navigation engine: a normalized tracked `value`, current-value bookkeeping, and the `aria-selected` selection writer. Components with a single selected value extend this instead.\n\nBehavior is tuned through small override hooks (`navigableOptions`, `allowHorizontalNavigation`, `leftNavigableOptions`, `rightNavigableOptions`, `horizontalAnchor`, `wrapAround`, `wrapAroundHorizontal`, `canEnterHorizontal`, `menuCanOpen`, `handleOpen`/`handleClose`, `exitToTrigger`, `optionElement`, `optionMatchesValue`, etc.) rather than by reimplementing key handling.\n\n### Horizontal navigation\n\nHorizontal navigation is now generalized in the same way as vertical navigation. Instead of a single hard-coded control on each side of an input, a component exposes arbitrarily-sized ordered lists via `leftNavigableOptions` and `rightNavigableOptions` (index 0 nearest the anchor). The anchor is dynamic — the active menu option when navigation started from the menu, otherwise the input/trigger — so `ArrowLeft`/`ArrowRight` step outward through a side, return to the anchor when moving inward past the first control, and stop at the outer edge (or wrap when `wrapAroundHorizontal` is enabled). Input consumers gate capture with `canEnterHorizontal` so arrow keys still move the caret until it reaches the field edge. The search and filter clear controls are now just the two-item case of this model.\n\n### Impact\n\nThe legacy `Spds::Input::KeyboardNavigable` and the filter-specific single-arrow-navigation implementations were removed, and the search/dropdown inputs and filter single-select button were migrated onto the unified bases. Behavior for existing consumers is unchanged; the win is a single navigation engine that new list/menu-style components can adopt without rebuilding keyboard support from scratch."
    },
    {
      "id": "8.9.0-argument-override-pattern-and-accurate-flex-fit-content-handling",
      "version": "8.9.0",
      "title": "Argument override pattern and accurate flex/fit-content handling",
      "date": "2026-06-17",
      "type": "enhancement",
      "tags": [
        "DS Maintenance",
        "Metadata"
      ],
      "components": [
        "Spds::Core::Base",
        "Spds::Core::Container"
      ],
      "services": [],
      "body": "This release introduces a reusable way to declare when one argument's value is silently\ndiscarded by another, and uses it to make `Spds::Core::Container`'s flex/`fit-content`\nhandling accurate and self-explanatory.\n\n### New: `Arg.overriddenBy(...)` authoring pattern\n\nDS authors can now declare, in component metadata, that an argument's value is overridden\n(silently ignored) when another argument is present:\n\n```js\nflex: Arg.string({ description: '...' }).overriddenBy([\n  { name: 'fitContent', reason: 'fit-content constrains both axes, so flex is ignored' },\n]),\n```\n\nUnlike `forbids` (which asserts/throws), this is **warn** severity — the value isn't illegal,\nit's just discarded — so it surfaces as a development/test-only console warning (deduped per\ncomponent instance) rather than an error. Entries support the same existence/`when` semantics\nas `forbids`/`requires`. The warning is wired into `Spds::Core::Base`'s `validateArguments`\nmodifier, so any component that includes `{{this.validateArguments}}` gets it for free.\n\nFor relationships that depend on runtime/CSS conditions a static `when` can't express, a\ncomponent may implement an `isArgumentOverridden(argName, entry)` hook that fully decides\nwhether the warning fires.\n\n### Container: accurate `@flex` vs `fit-content`\n\n`@flex` (the flex shorthand) makes a flex item fill its parent's main axis, which silently\ndefeats `width`/`height: fit-content` on that axis. The container previously discarded `@flex`\nin that case, but used its own `@column` as a proxy for the axis and treated every active\n`@flex` as conflicting. It now:\n\n- resolves the **parent's** true main axis (so the discard matches what actually renders), and\n- only treats `@flex` as conflicting when it actually makes the element non-content-sized\n  (`flex-grow > 0` or a non-`auto` basis).\n\nWhen `@flex` is genuinely overridden, a development warning now explains which `fit-content`\nargument discarded it and why.\n\n### Behavior changes\n\n- `@flex` values that stay content-sized (e.g. `flex: none`, `flex: initial`, or any\n  `grow: 0` / `basis: auto`) combined with a main-axis `fit-content` are **no longer\n  discarded** — they were never actually in conflict.\n- The individual flex longhand arguments (`@flexGrow`, `@flexBasis`, `@flexShrink`) now take\n  effect on the container (they are composed into the rendered flex). Previously they mapped\n  to CSS custom properties the container stylesheet did not consume, so they had no effect.\n- Providing an expanding `@flex` when the container's parent is **not** a flex layout now\n  emits a development warning (the flex has no effect in that case)."
    },
    {
      "id": "8.8.0-add-search-to-dropdown",
      "version": "8.8.0",
      "title": "Add search to dropdown",
      "date": "2026-06-24",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-386/add-search-to-dropdown",
      "tags": [
        "DS Maintenance",
        "Large Group Practice QoL Updates",
        "Incremental feature enhancement"
      ],
      "components": [
        "Spds::Action::Button::Dropdown",
        "Spds::Action::Button::Dropdown::Menu",
        "Spds::Core::Menu::Base",
        "Spds::Core::Menu::NoResults",
        "Spds::Core::Menu::Search",
        "Spds::Core::Menu::Search::Input",
        "Spds::Input::Dropdown::List",
        "Spds::Input::Dropdown::List::Menu",
        "Spds::Input::Dropdown::List::MultiselectMenu",
        "Spds::Input::Search",
        "Spds::Input::Search::Menu::Base",
        "Spds::Input::Search::Trigger"
      ],
      "services": [],
      "body": "Dropdown menus in DS components have been updated to include new search filter functionality. By default, this filter appears when 15 or more items are present in a menu, though this threshold is configurable.\n\n## Why\n\nPractices with large numbers of clinicians or clients would previously need to manually scroll through very large lists to find a clinician, client, or other list information. Now, they are able to filter the list items by typing into the search box, which acts as a sticky element at the top of the list when present.\n\n## Usage\n\nBy default, nothing needs to be done to get this working in the `Spds::Action::Button::Dropdown` or `Spds::Input::Dropdown::List` components. If a menu has 15 or more items in it, it will automatically display the search input, which is internally wired up and does not require outside configuration to properly filter the menu items.\n\nThe behavior can be customized with the following arguments, which are available on both `Spds::Action::Button::Dropdown` and `Spds::Input::Dropdown::List`:\n\n| Argument | Type | Description |\n| --- | --- | --- |\n| `@searchable` | boolean | Forces the search field on (`true`) or off (`false`), overriding the item-count threshold. When omitted, the field appears automatically once the threshold is met. |\n| `@searchThreshold` | number | Minimum number of items before the search field appears automatically. Defaults to `15`. |\n| `@searchPlaceholder` | string | Placeholder text shown in the search field. |\n| `@noResultsText` | string | Customizes the message shown when the active filter matches no items. Defaults to \"No matching results\". |\n\n### Behavior notes\n\n- **No results state:** When the active filter matches no items, a no-results message is displayed in place of the list (customizable via `@noResultsText`).\n- **Match highlighting:** Matching text within each item is bolded as the user types.\n- **Multiselect:** Filtering works in multiselect dropdown menus as well as single-select.\n\n## Internal modifications\n\nThe existing `Spds::Input::Search::Trigger` component has been generalized as the `Spds::Core::Menu::Search::Input` component, which allows for an identical search interface wherever this new core component is used. It has been inserted into the `Spds::Core::Menu::Base` component, which is the basis for all menus in the DS. See the [DS Core Menu](/styleguide?s=DS%20Core&ss=Menu) page for more information.\n\nThe `Spds::Input::Search::Trigger` refactor preserves its existing CSS class hooks (`spds-input-search-*`), so consumer styles and tests that target those classes are unaffected — this is not a breaking change.\n\nBecause `Spds::Core::Menu::Base` backs all DS menus, the in-menu search is explicitly disabled for `Spds::Input::Search`, which already provides its own trigger-based filtering. It can never render the in-menu search field, regardless of item count.\n\nThe `CloseOnClickOutside` modifier was updated to resolve containment using the event's composed path rather than the current target node. This makes \"click outside\" detection robust when an element inside the container (such as the search field's clear button) is removed from the DOM during the same click. This modifier is shared by modals and other dropdowns, so the improved behavior applies wherever it is used."
    },
    {
      "id": "8.7.1-fix-full-screen-modal-preview-pane-on-small-screen-sizes",
      "version": "8.7.1",
      "title": "Fix full screen modal preview pane on small screen sizes",
      "date": "2026-06-24",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-460/fix-full-screen-modal-preview-pane-on-small-screen-sizes",
      "tags": [
        "DS Maintenance"
      ],
      "components": [],
      "services": [],
      "body": "A change to how body width is calculated for the full screen modal on smaller screen sizes. The original requirements specified a minimum width of `624px`, which caused the preview pane to be forced out of the viewport at smaller screen sizes. This change leverages [container queries](https://developer.mozilla.org/en-US/docs/Web/CSS/Guides/Containment/Container_queries) to check the width of the parent and assign an appropriate width to the modal body, which allows both the body and preview pane to occupy the correct amount of the viewport."
    },
    {
      "id": "8.7.0-introduce-copy-button-component",
      "version": "8.7.0",
      "title": "Introduce copy button component",
      "date": "2026-06-23",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-487/introduce-copy-button-component",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button::Copy"
      ],
      "services": [],
      "body": "`Spds::Action::Button::Copy` is the canonical way to copy content to the user's clipboard, replacing the various one-off copy button implementations scattered across our apps.\n\nIt wraps `Spds::Action::Button::Variable`, so its appearance can be set to any DS button type via `@buttonType` (defaults to `secondary`).\n\n## Providing the content\n\nPass the value to copy directly with `@text`, or lazily with the `@getText` function (handy when the content is expensive to build or only known at click time). To also place a rich HTML flavor on the clipboard, provide `@html` (or `@getHtml`) alongside the plain text.\n\n```handlebars\n<Spds::Action::Button::Copy @text={{this.shareUrl}} />\n\n<Spds::Action::Button::Copy @getText={{this.buildSummary}} @buttonType=\"ghost\" />\n```\n\n## Behavior\n\n- Uses the native [Clipboard API](https://developer.mozilla.org/en-US/docs/Web/API/Clipboard) when available, falling back to `document.execCommand('copy')` for browsers without full support.\n- After a successful copy, the default label briefly swaps to `@copiedLabel` (\"Copied\") and a visually hidden live region announces the result to assistive technology.\n- If the copy fails, the label briefly swaps to `@copyErrorLabel` (\"Error copying to clipboard\"), the failure is announced to assistive technology, and the button is disabled until the error clears.\n- The block form yields the copied and error state for custom labels: `<Spds::Action::Button::Copy @text={{x}} as |state|>{{if state.copied \"Copied\" (if state.error \"Error\" \"Copy\")}}</Spds::Action::Button::Copy>`.\n- An optional `@onCopy` hook runs after a successful copy and can return a promise to extend the copied state. An optional `@onCopyError` hook is called with the error when a copy fails."
    },
    {
      "id": "8.6.1-address-missing-resource-links-in-the-style-guide",
      "version": "8.6.1",
      "title": "Address missing resource links in the style guide",
      "date": "2026-06-23",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-424/update-zh-links-in-component-metadata",
      "tags": [
        "Documentation",
        "Metadata"
      ],
      "components": [],
      "services": [],
      "body": "With the introduction of the metadata to DS components, there has been a large restructuring in the way data is served to the style guide. Each component now exports a metadata object that contains the data defining its API, the documentation shown in the style guide, and its resource links.\n\nThis fix addresses a few small issues that were resulting in many resource links not being displayed properly in the style guide:\n\n* Outdated links pointing to ZeroHeight directly instead of simplepractice.design\n* Missing Figma links\n* GitHub links being lost in metadata construction"
    },
    {
      "id": "8.5.0-introduce-toggle-input-component",
      "version": "8.5.0",
      "title": "Introduce toggle input component",
      "date": "2026-06-15",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-426/introduce-toggle-component",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Toggle",
        "Spds::Input::Labeled::Base"
      ],
      "services": [],
      "body": "A new **Toggle** input component (`Spds::Input::Toggle`) renders an accessible,\nanimated on/off switch. Under the hood it is a labeled checkbox input, so it\nplugs into the existing `Spds::Input::Labeled::Base` plumbing and behaves like\nthe other SPDS form inputs.\n\n## Usage\n\n```gjs\n<Spds::Input::Toggle\n  @label=\"Email notifications\"\n  @checked={{this.notificationsEnabled}}\n  @onClick={{this.toggleNotifications}}\n/>\n```\n\nThe label can also be supplied as the default block or a named `label` block\ninstead of the `@label` argument.\n\n## Arguments\n\n* `@onClick` (required): handler invoked when the toggle is clicked.\n* `@onChange`, `@onBlur`, `@onFocus`: additional input event handlers.\n* `@checked` (default `false`): the toggle's on/off state.\n* `@label`: text label, with default/`label` block alternatives.\n* `@labelFirst` (default `false`): render the label before the input instead of\n  after.\n* `@size` (default `default`): one of `default`, `large`, `small`.\n* `@animated` (default `true`): animate the knob transition between states.\n* `@disabled`: render the toggle in a disabled state.\n* `@required`, `@value`, `@id`, `@gap` (default `8px`): standard labeled-input\n  arguments forwarded to the base.\n* `@tooltipContent` / `@tooltipPlacement` (default `top-left`): attach a tooltip\n  to the toggle, consistent with other SPDS components.\n\n## Supporting changes\n\n`Spds::Input::Labeled::Base` was extended to support the toggle's mask/label\nlayout, alongside small adjustments to the core container, input, and layout\nprimitives it relies on."
    },
    {
      "id": "8.4.0-introduce-loading-spinner-component",
      "version": "8.4.0",
      "title": "Introduce loading spinner component",
      "date": "2026-06-15",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-95/introduce-loading-spinner-component",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Indicator::LoadingSpinner",
        "Spds::Indicator::LoadingOverlay",
        "Spds::Feedback::LoadingOverlay::Container"
      ],
      "services": [
        "AlertManager",
        "Spds::LoadingOverlay"
      ],
      "body": "This introduces a family of loading indicators, plus a service and modifier for\nattaching loading states to arbitrary DOM elements.\n\n## Components\n\n1. **Loading spinner** (`Spds::Indicator::LoadingSpinner`) - the basic animated\n   spinner. Use it when the expected wait is more than a second, and keep only\n   one spinner visible on a page at a time.\n2. **Loading overlay** (`Spds::Indicator::LoadingOverlay`) - centers a spinner\n   over content with a backdrop that matches the modal backdrop color. It can\n   cover the full viewport (`@fixed={{true}}`) or be scoped to a specific DOM\n   element. A scoped overlay uses `position: absolute`, so its container **must**\n   be set up with `position: relative`.\n3. **Loading overlay container** (`Spds::Feedback::LoadingOverlay::Container`) -\n   like the containers for other SPDS components (toasts, tooltips), it registers\n   as a handler for events managed by the wrapper service around the\n   `alert-manager` service. A single instance lives at the application root.\n\n## Service\n\nThe new `spds/loading-overlay` service programmatically attaches loading states\nto arbitrary DOM elements by passing a reference to the element (or its `id`) to\nits `show` method. It also provides `update` for changing a rendered overlay's\noptions and `hide` for dismissing it. Calling `show` with no element (or options\nonly) renders a full-viewport overlay.\n\n```javascript\n// Element-scoped\nthis.spdsLoadingOverlay.show(this.listEl, { ariaLabel: 'Loading clients' });\nthis.spdsLoadingOverlay.hide(this.listEl);\n\n// Full-viewport\nthis.spdsLoadingOverlay.show();\nthis.spdsLoadingOverlay.hide();\n```\n\nThe service only ever broadcasts an `id` plus presentational options, never an\nelement reference. The container resolves the render target by `id` at render\ntime.\n\n## Modifier\n\n`{{spds-loading-overlay}}` is an ergonomic wrapper around the service that makes\nadding an overlay to an element trivial. Toggling its `loading` argument adds or\nremoves a loading overlay on whatever element the modifier is invoked on, without\ninjecting the service or threading element references through your component.\n\n```handlebars\n<div {{spds-loading-overlay loading=this.isSaving ariaLabel=\"Saving\"}}>\n  ...form...\n</div>\n```\n\nThe target element must be a positioned container (`position: relative`,\n`absolute`, or `fixed`). The modifier assigns an `id` to the element if one isn't\nalready present so the service can route show/hide events, and it calls `hide` on\nteardown.\n\n## Notes\n\n* The spinner accepts `@color` (default `neutral`) and `@size` (default\n  `medium`), and exposes an `@ariaLabel` (default `Loading`) for accessibility.\n  It renders with `role=\"status\"`.\n* The overlay forwards `@color` and `@ariaLabel` to its spinner and defaults the\n  spinner `@size` to `x-large`. Pass `@when={{this.isLoading}}` to keep the\n  overlay mounted and fade it out before it is removed from the DOM, or wrap it\n  in a conditional to mount/unmount it directly.\n* The `Spds::Feedback::LoadingOverlay::Container` must be present at the\n  application root for the service and modifier to work. It is already included\n  in the EHR application template."
    },
    {
      "id": "8.3.0-variable-button-component",
      "version": "8.3.0",
      "title": "Variable button component",
      "date": "2026-06-04",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-446/introduce-variable-button-component",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button::Dropdown",
        "Spds::Action::Button::Split",
        "Spds::Action::Button::Variable",
        "Spds::Action::Button::Filter::Trigger"
      ],
      "services": [],
      "body": "A new **Variable** button component renders any simple SPDS button type through a\nsingle `@buttonType` argument, instead of branching in a template to pick one\nbutton over another.\n\n## Why\n\nSeveral call sites need a button whose type changes based on a condition. Without\na variable button, that requires template logic to switch between, say, a\n`Primary` and a `Destructive` button even when every other argument is identical.\nThat bloats templates and duplicates the type-selection logic in multiple places.\n\n## Usage\n\n```gjs\n<Spds::Action::Button::Variable\n  @buttonType={{if @isDangerous \"destructive\" \"primary\"}}\n  @text=\"Save\"\n/>\n```\n\n`@buttonType` accepts any of the simple button types\n(`agent-ghost`, `agent-primary`, `agent-secondary`, `destructive`, `ghost`,\n`link`, `negative`, `primary`, `promotional`, `secondary`, `tertiary`) and falls\nback to `primary` when the value is unrecognized. Shared arguments\n(`@autofocus`, `@disabled`, `@text`, the `fitContent*`/`inline` container\noptions, and a block) are forwarded to the resolved button.\n\n## Internal simplification\n\nThe **split** button and the **dropdown**, **split**, and **filter** trigger\ncomponents now lean on the variable button for their type selection, removing the\nduplicated branching logic those components previously carried."
    },
    {
      "id": "8.2.0-release-note-section",
      "version": "8.2.0",
      "title": "Release note section",
      "date": "2026-06-04",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-461/add-a-release-notes-section-to-the-engineering-style-guide",
      "tags": [
        "styleguide",
        "documentation"
      ],
      "components": [],
      "services": [],
      "body": "The engineering style guide now has a **Release Notes** section for the\nSimplePractice Design System.\n\n## Authoring\n\nRelease notes live as markdown files in `addon/release-notes/*.md`. Each note\ncarries frontmatter (`version`, `title`, `date`, `type`, optional `tags`,\n`components`, and `services`) followed by a free-form markdown body. See the\n[authoring guide](https://github.com/SimplePractice/ember-simplepractice/blob/staging/addon/release-notes/README.md)\nfor the full field reference.\n\n## How it ships\n\n- `scripts/build-release-notes.mjs` aggregates the markdown into a generated\n  module (`utils/spds/release-notes-data.js`) before every addon build.\n- The style guide loads that module with a dynamic `import()`, so the archive is\n  code-split into its own chunk and never enters the main app bundle.\n\n## Browsing\n\nThe section renders each note as a card and can be filtered by **version**,\n**type**, **component**, **service**, and **tag**. Tags on a card are interactive and update\nthe matching filter when clicked. Each entry also has a **Copy link** action\nthat produces a shareable URL deep-linked to that release\n(`?s=Release Notes&release=<version>`) for posting in Slack or tickets."
    },
    {
      "id": "8.1.1-update-time-picker-component-to-match-ds-standards",
      "version": "8.1.1",
      "title": "Update time picker component to match DS standards",
      "date": "2026-05-28",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-443",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Input::TimePicker"
      ],
      "services": [],
      "body": "Rebuilds the time picker on the shared DS core library and infrastructure while preserving its existing behavior."
    },
    {
      "id": "8.1.0-remove-metadata-library-generation-script",
      "version": "8.1.0",
      "title": "Remove metadata library generation script",
      "date": "2026-05-28",
      "type": "cleanup",
      "issue": "https://linear.app/simplepractice/issue/DES-442",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [],
      "services": [],
      "body": "The metadata library generation script was an experiment in how to properly expose DS component metadata for LLM ingestion. We've discovered that the simple presence of the metadata objects in the component files seems to be enough in conjunction with the design-system skill written by @tkraak, so this code is unnecessary and can be wholly excised."
    },
    {
      "id": "8.0.0-simplify-mechanism-for-mapping-css-in-ds-components",
      "version": "8.0.0",
      "title": "Simplify mechanism for mapping CSS in DS components",
      "date": "2026-05-21",
      "type": "breaking",
      "issue": "https://linear.app/simplepractice/issue/DES-440",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Action::SegmentedControl",
        "Spds::Container::Accordion",
        "Spds::Container::Card",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::CharacterCounter",
        "Spds::Core::Container",
        "Spds::Core::HelperText",
        "Spds::Core::Input",
        "Spds::Core::Label",
        "Spds::Core::Menu",
        "Spds::Core::Modal",
        "Spds::Core::MultiselectClearFilter",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::EmptyState",
        "Spds::Feedback::FeatureBanner",
        "Spds::Feedback::Toast",
        "Spds::Feedback::Tooltip",
        "Spds::Indicator::Badge",
        "Spds::Indicator::Tag",
        "Spds::Input::Dropdown",
        "Spds::Input::Group",
        "Spds::Input::Labeled",
        "Spds::Input::MenuParent",
        "Spds::Input::Search",
        "Spds::Modal::Flyout",
        "Spds::Modal::FullScreen"
      ],
      "services": [],
      "body": "This is a *breaking change* that's mostly an internal update, but it does affect some usage we’ve seen in the EHR where components extend `Spds::Core::Base`.\n\nFor background: that base component has a handy mechanism for mapping argument or internal attribute values to CSS classes or custom properties. Quick example: a Boolean `@hasBorder` can automatically add a has-border class when it’s true, without hand-rolling class logic in every template.\n\nPreviously, that depended on two internal arrays per concern — e.g. `classesToMapToArgs` and `classesToMapToAttrs` (and the same split for custom properties with `propsToMapToArgs` / `propsToMapToAttrs`). This required an additional decision point about where the component should look for each value.\n\nIn this release, we’ve leveraged some of the recent component metadata work to unify these lists into single arrays: `classesToMap` and `propsToMap`. The component resolves each entry the same way (`this[key] ?? this.args[key]`), so `args` and internal state can live in one list. For most app usage, nothing changes — the same `@hasBorder` argument still produces the same class. The win is for DS authors and anyone extending base components: less bookkeeping, clearer patterns, and updated wiki/docs."
    },
    {
      "id": "7.10.2-remove-max-width-from-feature-banner",
      "version": "7.10.2",
      "title": "Remove max width from feature banner",
      "date": "2026-05-20",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-444",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Feedback::FeatureBanner"
      ],
      "services": [],
      "body": "`max-width` has been removed from the feature banner component, allowing it to flex to fill up all available width. This brings it more in line with the [simplepractice.design](https://www.simplepractice.design/1d0abbc0a/p/84e503-feature-banner/b/932965) guideline."
    },
    {
      "id": "7.10.1-apply-a-z-index-to-the-progress-bar-on-the-full-screen-modal",
      "version": "7.10.1",
      "title": "Apply a z-index to the progress bar on the full screen modal",
      "date": "2026-05-20",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-438",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Modal::FullScreen"
      ],
      "services": [],
      "body": "`z-index` has been applied to the progress bar in the full screen modal header to prevent a layering issue where the body of the modal could sometimes partially cover the bar"
    },
    {
      "id": "7.10.0-introduce-a-design-system-architecture-skill",
      "version": "7.10.0",
      "title": "Introduce a design system architecture skill",
      "date": "2026-05-19",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-439",
      "tags": [
        "LLM Tooling"
      ],
      "components": [],
      "services": [],
      "body": "Adds a design-system architecture skill that teaches LLM tools how to build with core components, services, and DS patterns; trialed in the addon before moving to docker-dev.\n\nAlso adds a create-ds-component skill that sits on top of the architecture skill to allow creation of a new DS component by invoking the skill with a Linear issue URL."
    },
    {
      "id": "7.10.0-convert-toasts-to-use-the-popover-api",
      "version": "7.10.0",
      "title": "Convert toasts to use the popover API",
      "date": "2026-05-15",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-62",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Base",
        "Spds::Core::Modal",
        "Spds::Feedback::Toast",
        "Spds::Modal::Acknowledgement",
        "Spds::Modal::Announcement",
        "Spds::Modal::Container",
        "Spds::Modal::Destructive",
        "Spds::Modal::Flyout",
        "Spds::Modal::FullScreen",
        "Spds::Modal::ImageCrop",
        "Spds::Modal::Standard",
        "Spds::Modal::Transactional",
        "Spds::Navigation::Tabs"
      ],
      "services": [
        "AlertBanner",
        "Modal",
        "Toast"
      ],
      "body": "Previously, we had two separate sets of methods defined, with some being needed to properly create toasts within modals (`local` prefix), and some being for general use. All of the `toast.local` methods have been deprecated in favor of the global methods! For now, the local methods are still in place, but under the hood they will be forwarding to the global methods and will trigger a deprecation warning in your dev console. This reduces our available toast API to four methods:\n\n* `error`\n* `fileUploadToast`\n* `success`\n* `system`\n\nSome background on this change: toasts are upgraded to use the [native popover API](https://developer.mozilla.org/en-US/docs/Web/API/Popover_API) to properly layer them on top of content, even open modals. Note that this may affect test selector usage as many tests were looking inside the toast container for the expected text, which will no longer work. Toasts are now either direct children of the document body, or of the topmost open modal, and all existing tests have been updated to reflect this change as part of this rollout.\n\nThe `spds/modal` service now automatically tracks the topmost open modal through its new `topmostOpenModal` attribute. This will change dynamically as DS modals open and close (they automatically register themselves with the service on creation).\n\nNote that directly calling `alertManager.broadcast` to create a toast is discouraged, as are the convenience methods that are only local to the EHR. Some of these will also trigger deprecations. Attempting to add a new `alertManager.broadcast('localToast', ...)` call will result in a hard error, as there are no longer any handlers registered for the associated events. Instead, the [spds/toast service](https://tr01.staging.simplepractice.com/styleguide?s=DS%20Services&ss=Toast%20service) should be used for all toast creation"
    },
    {
      "id": "7.9.0-promotional-variant-for-spds-action-button",
      "version": "7.9.0",
      "title": "Promotional variant for SPDS action button",
      "date": "2026-05-13",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-428",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button::Promotional"
      ],
      "services": [],
      "body": "Adds a promotional (green) variant of the action button across all existing button variants."
    },
    {
      "id": "7.8.0-ai-agent-variant-for-spds-action-button",
      "version": "7.8.0",
      "title": "AI agent variant for SPDS action button",
      "date": "2026-05-06",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-417",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button::Agent::Ghost",
        "Spds::Action::Button::Agent::Primary",
        "Spds::Action::Button::Agent::Secondary"
      ],
      "services": [],
      "body": "Adds an AI agent (plum) variant of the action button to indicate AI-driven actions, applied across all existing button variants."
    },
    {
      "id": "7.7.1-allow-search-input-external-update",
      "version": "7.7.1",
      "title": "Allow search input external update",
      "date": "2026-03-19",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-389",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Menu",
        "Spds::Input::Dropdown",
        "Spds::Input::Group",
        "Spds::Input::MenuParent",
        "Spds::Input::Search"
      ],
      "services": [],
      "body": "Allows a search input's multi-select selections to be updated by passing in values through arguments instead of simply updating through user interaction."
    },
    {
      "id": "7.7.0-introduce-tooltip-component",
      "version": "7.7.0",
      "title": "Introduce tooltip component",
      "date": "2026-03-12",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-274",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Core::Base",
        "Spds::Feedback::Tooltip"
      ],
      "services": [
        "AlertManager",
        "Tooltip"
      ],
      "body": "This includes a few updates:\n\n* A new tooltip component which can easily be added to any DOM element by passing in a reference to the element as @anchorElement to the component\n* A new tooltip service for adding tooltips programmatically (this drives the next feature in the list)\n* Out of the box integration with all DS buttons, which now accept a @tooltipContent argument that automatically registers a tooltip for the button. This works for all existing buttons, so if you have any DS buttons that are wrapped in the legacy tooltip, it's a simple change to upgrade by passing the new argument and removing the legacy tooltip wrapper\n\nSome notes:\n\n1. [simplepractice.design](https://www.simplepractice.design/1d0abbc0a/p/89757c-tooltip/t/76ecdf6dad) sets hard limits on content type for tooltips, such that they only support text. Any HTML included should be for formatting purposes only. Interactive content is not supported\n2. DS buttons now accept the following arguments for customizing tooltip appearance:\n    * `@tooltipContent` (string, required): Body text displayed in the tooltip. Tooltips will not appear if no content is provided, even with the other arguments present\n    * `@tooltipOffset` (string, optional): Gap between tooltip and anchor (default: 8px, can accept other units)\n    * `@tooltipPlacement` (string, optional): Position relative to anchor (default: top-middle, see the style guide for all possible values)\n    * `@tooltipTitle` (string, optional): Heading displayed above the content\n\n3. Tooltips appear for both mouse hover and keyboard focus of the anchor element\n4. DS components other than buttons may partially support tooltips at this time, though full support will require an additional body of work to ensure\n5. Tooltips will automatically reposition to the opposite side of the anchor element if they are too close to the edge of the screen\n6. Tooltips use the browser native popover API under the hood, which means that they are rendered in the top layer of the DOM and so will always appear above other content. This guarantees that they will always be visible to the user as long as an element can be hovered or focused via keyboard nav (any elements in the main DOM flow are rendered inert when DS modals are open, and so cannot receive events)"
    },
    {
      "id": "7.6.10-update-existing-components-to-use-metadata",
      "version": "7.6.10",
      "title": "Update existing components to use metadata",
      "date": "2026-03-04",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-264",
      "tags": [
        "DS Maintenance",
        "Internal",
        "metadata",
        "styleguide",
        "documentation",
        "validations"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Action::SegmentedControl",
        "Spds::Container::Accordion",
        "Spds::Container::Card",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::CharacterCounter",
        "Spds::Core::Container",
        "Spds::Core::HelperText",
        "Spds::Core::Input",
        "Spds::Core::Label",
        "Spds::Core::Menu",
        "Spds::Core::Modal",
        "Spds::Core::MultiselectClearFilter",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::EmptyState",
        "Spds::Feedback::FeatureBanner",
        "Spds::Feedback::Toast",
        "Spds::Feedback::Tooltip",
        "Spds::Indicator::Badge",
        "Spds::Indicator::Tag",
        "Spds::Input::Dropdown",
        "Spds::Input::Group",
        "Spds::Input::Labeled",
        "Spds::Input::MenuParent",
        "Spds::Input::Search",
        "Spds::Modal::Flyout",
        "Spds::Modal::FullScreen",
        "Spds::Navigation::Tabs"
      ],
      "services": [],
      "body": "Components now each define a custom Metadata object that contains a detailed specification for the component's accepted arguments used to drive the component data validations, as well as documentation data for the engineering style guide.\n\nComponent metadata is also used by our LLM skills to let the tools understand how to use DS components to build features, or to build new DS components using our lower level patterns."
    },
    {
      "id": "7.5.1-fix-image-crop-modal",
      "version": "7.5.1",
      "title": "Fix Image Crop Modal",
      "date": "2025-12-18",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-287",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Core::Modal",
        "Spds::Modal::ImageCrop"
      ],
      "services": [],
      "body": "Converts the image crop modal to the SPDS standard modal so it can be accessed while an SPDS flyout is open."
    },
    {
      "id": "7.5.0-introduce-ds-split-button-component",
      "version": "7.5.0",
      "title": "Introduce DS split button component",
      "date": "2025-12-15",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-286",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::Container"
      ],
      "services": [
        "AlertManager"
      ],
      "body": "Introduce a DS split button component with style guide documentation, intended to replace the legacy split-button implementation."
    },
    {
      "id": "7.4.0-update-new-spds-services-with-additional-functionality",
      "version": "7.4.0",
      "title": "Update new spds services with additional functionality",
      "date": "2025-12-10",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-298",
      "tags": [],
      "components": [
        "Spds::Feedback::Toast"
      ],
      "services": [
        "Modal",
        "Toast"
      ],
      "body": "Adds CTA data to the toast service and confirmation-modal shorthands (`confirm` and `destructiveConfirm`) to the modal service with overridable defaults."
    },
    {
      "id": "7.3.0-make-modals-deployable-through-alertmanager-service",
      "version": "7.3.0",
      "title": "Make modals deployable through alertManager service",
      "date": "2025-11-24",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-33",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Core::Modal",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::Toast",
        "Spds::Modal::Container",
        "Spds::Modal::FullScreen"
      ],
      "services": [
        "AlertManager",
        "AlertBanner",
        "Modal",
        "Toast"
      ],
      "body": "Adds a modal container that renders modals generated through the `spds/modal` wrapper around the `alertManager` service, so any modal type can be created programmatically above page content."
    },
    {
      "id": "7.2.0-move-ds-badge-component-to-addon",
      "version": "7.2.0",
      "title": "Move DS badge component to addon",
      "date": "2025-11-21",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-267",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Indicator::Badge"
      ],
      "services": [],
      "body": "Moves the badge component into the `ember-simplepractice` addon. Previously these were added directly in the EHR."
    },
    {
      "id": "7.1.0-introduce-ds-accordion-component",
      "version": "7.1.0",
      "title": "Introduce DS Accordion Component",
      "date": "2025-11-19",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-260",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Container::Accordion",
        "Spds::Container::Group",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::Container",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::FeatureBanner",
        "Spds::Input::Group",
        "Spds::Input::KeyboardNavigable",
        "Spds::Layout::Variable",
        "Spds::Modal::FullScreen"
      ],
      "services": [],
      "body": "Introduces accordion and accordion group components with `onOpen`/`onClose` actions, a disabled state, and extensive layout customization, plus style guide documentation."
    },
    {
      "id": "7.0.1-availability-flyout-can-t-scroll",
      "version": "7.0.1",
      "title": "Availability flyout can't scroll",
      "date": "2025-11-14",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-263",
      "tags": [],
      "components": [
        "Spds::Modal::Flyout"
      ],
      "services": [],
      "body": "Fixes scrolling inside flyouts."
    },
    {
      "id": "6.9.0-introduce-ds-layout-components",
      "version": "6.9.0",
      "title": "Introduce DS Layout Components",
      "date": "2025-11-03",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-247",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Action::SegmentedControl",
        "Spds::Container::Card",
        "Spds::Container::Group",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::Container",
        "Spds::Core::HelperText",
        "Spds::Core::Label",
        "Spds::Core::Menu",
        "Spds::Core::ProgressBar",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::EmptyState",
        "Spds::Feedback::FeatureBanner",
        "Spds::Feedback::Toast",
        "Spds::Indicator::TagGroup",
        "Spds::Indicator::Tag",
        "Spds::Input::Checkbox",
        "Spds::Input::Dropdown",
        "Spds::Input::Labeled",
        "Spds::Input::Search",
        "Spds::Input::Text",
        "Spds::Layout::Flex",
        "Spds::Layout::Grid",
        "Spds::Modal::Announcement",
        "Spds::Modal::Flyout",
        "Spds::Modal::FullScreen",
        "Spds::Modal::Standard"
      ],
      "services": [],
      "body": "Adds design-system layout components (flex row/column and their reverse variants, plus a grid container) and extends the core container to support grid and CSS-custom-property-driven layout."
    },
    {
      "id": "6.8.1-account-for-fastboot-in-spds-components",
      "version": "6.8.1",
      "title": "Account for FastBoot in SPDS components",
      "date": "2025-10-23",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-236",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Container",
        "Spds::Core::Modal",
        "Spds::Input::TimePicker"
      ],
      "services": [
        "BodyScrollManager"
      ],
      "body": "Guards SPDS components, modifiers, services, and utilities against missing `document` references so they work under FastBoot."
    },
    {
      "id": "6.7.4-character-counter-over-class-applied-too-early",
      "version": "6.7.4",
      "title": "Character counter over class applied too early",
      "date": "2025-09-19",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-205",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::CharacterCounter"
      ],
      "services": [],
      "body": "Fixes the character counter so the `over` styling only applies when the count exceeds the limit, not when it equals it."
    },
    {
      "id": "6.7.0-introduce-address-autocomplete-component",
      "version": "6.7.0",
      "title": "Introduce address autocomplete component",
      "date": "2025-08-28",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/CLMASST-522",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Core::Menu",
        "Spds::Input::AddressAutocomplete",
        "Spds::Input::Dropdown",
        "Spds::Input::MenuParent",
        "Spds::Input::Search"
      ],
      "services": [],
      "body": "Adds a design-system version of the address autocomplete component."
    },
    {
      "id": "6.6.1-reorganize-ds-components",
      "version": "6.6.1",
      "title": "Reorganize DS components",
      "date": "2025-08-25",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-174",
      "tags": [
        "DS Maintenance",
        "Internal"
      ],
      "components": [
        "Spds::Action::SegmentedControl",
        "Spds::AlertBanner::Container",
        "Spds::AlertBanner::GlobalContainer",
        "Spds::AlertBanner::Message",
        "Spds::EmptyState::Body",
        "Spds::FeatureBanner::Body",
        "Spds::FeatureBanner::CtaContainer",
        "Spds::FeatureBanner::Header",
        "Spds::Feedback::AlertBanner",
        "Spds::Feedback::EmptyState",
        "Spds::Feedback::FeatureBanner",
        "Spds::Feedback::Toast",
        "Spds::Flyout::Body",
        "Spds::Flyout::Footer",
        "Spds::FullScreenModal::Header",
        "Spds::Indicator::TagGroup",
        "Spds::Indicator::Tag",
        "Spds::Input::TimePicker",
        "Spds::Modal::Acknowledgement",
        "Spds::Modal::Announcement",
        "Spds::Modal::Destructive",
        "Spds::Modal::Flyout",
        "Spds::Modal::FullScreen",
        "Spds::Modal::Standard",
        "Spds::Modal::Transactional",
        "Spds::Navigation::Tabs",
        "Spds::TimePicker::DoneBox",
        "Spds::TimePicker::Trigger",
        "Spds::Toast::Container",
        "Spds::Toast::Message"
      ],
      "services": [],
      "body": "Reorganizes the design-system components into folders that mirror zeroheight, using shell components so consuming apps keep working without immediate changes."
    },
    {
      "id": "6.6.0-introduce-dropdown-button-component",
      "version": "6.6.0",
      "title": "Introduce dropdown button component",
      "date": "2025-08-07",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/CLMASST-505",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Core::Button",
        "Spds::Core::Menu",
        "Spds::Input::Dropdown",
        "Spds::Input::Text",
        "Spds::Toast::Message"
      ],
      "services": [],
      "body": "Adds a design-system dropdown button component, following the DS designs for its appearance."
    },
    {
      "id": "6.5.4-fix-button-disabled-state",
      "version": "6.5.4",
      "title": "Fix button disabled state",
      "date": "2025-07-21",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-152",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Core::Button",
        "Spds::Core::Menu",
        "Spds::Input::Dropdown",
        "Spds::Input::Search"
      ],
      "services": [],
      "body": "Fixes the button disabled state so each button type matches the design specs."
    },
    {
      "id": "6.5.3-make-alertbanner-body-alignment-composable",
      "version": "6.5.3",
      "title": "Make AlertBanner body alignment composable",
      "date": "2025-07-14",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-155",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::AlertBanner::Message"
      ],
      "services": [],
      "body": "Adds `@bodyAlignment` and `@bodyTag` params to `Spds::AlertBanner::Message` to make the body layout composable."
    },
    {
      "id": "6.5.0-introduce-filter-button-component",
      "version": "6.5.0",
      "title": "Introduce filter button component",
      "date": "2025-07-07",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/ECD-197",
      "tags": [
        "DS Component Creation",
        "External Contribution"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::Core::Menu"
      ],
      "services": [],
      "body": "Adds the missing SPDS filter button component, aligned with the Figma designs, with default, hover, focus, and active states."
    },
    {
      "id": "6.4.2-ds-modal-stacking-order-issue-in-percy",
      "version": "6.4.2",
      "title": "DS modal stacking order issue in percy",
      "date": "2025-06-12",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-153",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Core::Modal",
        "Spds::Input::Labeled",
        "Spds::Modal::Announcement",
        "Spds::Modal::Standard"
      ],
      "services": [],
      "body": "Fixes a modal stacking-order issue surfaced in Percy visual tests."
    },
    {
      "id": "6.4.0-introduce-card-component",
      "version": "6.4.0",
      "title": "Introduce card component",
      "date": "2025-05-27",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/CLMASST-296",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Container::Card",
        "Spds::Container::Group::Card"
      ],
      "services": [],
      "body": "Adds a design-system card container built to the SPDS guidelines and Figma specs."
    },
    {
      "id": "6.3.0-introduce-button-components-to-spds",
      "version": "6.3.0",
      "title": "Introduce button components to SPDS",
      "date": "2025-05-21",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/CLMASST-263",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Action::Button",
        "Spds::AlertBanner::Message",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Flyout::Header",
        "Spds::FullScreenModal::Footer",
        "Spds::FullScreenModal::Header",
        "Spds::Input::Dropdown",
        "Spds::Input::Search",
        "Spds::Modal::Announcement",
        "Spds::Modal::Shared",
        "Spds::Modal::Standard",
        "Spds::TimePicker::DoneBox",
        "Spds::Toast::Message"
      ],
      "services": [],
      "body": "Adds the SPDS button family — primary, secondary, tertiary, ghost, negative, destructive, and close — so buttons are styled consistently and follow the design system guidelines.\n\nEach button type extends the `Spds::Core::Button` component, which houses all shared functionality. The specific button types act as preconfigured buttons with their own stylesheets."
    },
    {
      "id": "6.2.1-replace-color-tokens-in-time-picker",
      "version": "6.2.1",
      "title": "Replace color tokens in time picker",
      "date": "2025-05-09",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-144",
      "tags": [
        "Design Tokens H1"
      ],
      "components": [
        "Spds::TimePicker::DoneBox",
        "Spds::TimePicker::Trigger"
      ],
      "services": [],
      "body": "Replaces primitive color tokens in the time picker with alias and component tokens."
    },
    {
      "id": "6.1.2-use-zeroheight-api-to-feed-style-dictionary",
      "version": "6.1.2",
      "title": "Use zeroheight api to feed style dictionary",
      "date": "2025-04-23",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-129",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "services": [],
      "body": "Feeds the style dictionary from the zeroheight API."
    },
    {
      "id": "6.0.4-make-updates-to-modals",
      "version": "6.0.4",
      "title": "Make updates to modals",
      "date": "2025-04-07",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-134",
      "tags": [
        "Full Screen Modal"
      ],
      "components": [
        "Spds::FullScreenModal::Footer",
        "Spds::Modal::Acknowledgement",
        "Spds::Modal::Announcement",
        "Spds::Modal::Destructive",
        "Spds::Modal::Shared",
        "Spds::Modal::Transactional"
      ],
      "services": [],
      "body": "Makes the full screen modal back button optional, adds a `disabled` option to the primary button, and adds a local toast container."
    },
    {
      "id": "6.0.2-fix-feature-banner-body",
      "version": "6.0.2",
      "title": "Fix feature banner body",
      "date": "2025-04-04",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-133",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::FeatureBanner::Body"
      ],
      "services": [],
      "body": "Fixes the feature banner body rendering."
    },
    {
      "id": "6.0.1-introduce-core-components",
      "version": "6.0.1",
      "title": "Introduce core components",
      "date": "2025-03-28",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-121",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::AlertBanner::Container",
        "Spds::AlertBanner::GlobalContainer",
        "Spds::AlertBanner::Message",
        "Spds::Core::Base",
        "Spds::Core::Button",
        "Spds::Core::CharacterCounter",
        "Spds::Core::Container",
        "Spds::Core::HelperText",
        "Spds::Core::Input",
        "Spds::Core::Label",
        "Spds::Core::Menu",
        "Spds::Core::Modal",
        "Spds::Core::MultiselectClearFilter",
        "Spds::Core::ProgressBar",
        "Spds::EmptyState::Body",
        "Spds::FeatureBanner::Body",
        "Spds::FeatureBanner::CtaContainer",
        "Spds::FeatureBanner::Header",
        "Spds::Flyout::Body",
        "Spds::Flyout::Footer",
        "Spds::Flyout::Header",
        "Spds::FullScreenModal::Body",
        "Spds::FullScreenModal::Footer",
        "Spds::FullScreenModal::Header",
        "Spds::FullScreenModal::Preview",
        "Spds::Input::Base",
        "Spds::Input::CharacterCounter",
        "Spds::Input::Checkbox",
        "Spds::Input::Dropdown",
        "Spds::Input::Group",
        "Spds::Input::KeyboardNavigable",
        "Spds::Input::Labeled",
        "Spds::Input::MenuParent",
        "Spds::Input::RadioButton",
        "Spds::Input::Search",
        "Spds::Input::Text",
        "Spds::Menu::Base",
        "Spds::Menu::Item",
        "Spds::Menu::NoResults",
        "Spds::Modal::Acknowledgement",
        "Spds::Modal::Announcement",
        "Spds::Modal::Destructive",
        "Spds::Modal::Shared",
        "Spds::Modal::Standard",
        "Spds::Modal::Transactional",
        "Spds::SegmentedControl::Button",
        "Spds::Shared::HelperText",
        "Spds::Shared::Label",
        "Spds::Shared::MultiselectClearFilter",
        "Spds::TimePicker::DoneBox",
        "Spds::TimePicker::Trigger",
        "Spds::Toast::Message"
      ],
      "services": [],
      "body": "Introduces `spds/core` — low-level, reusable building-block components and patterns that make it easier to compose new design-system and feature components."
    },
    {
      "id": "5.43.5-replace-color-tokens-in-modal",
      "version": "5.43.5",
      "title": "Replace color tokens in modal",
      "date": "2025-02-18",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-113",
      "tags": [
        "Design Tokens"
      ],
      "components": [
        "Spds::Modal::Announcement",
        "Spds::Modal::Shared",
        "Spds::Modal::Standard"
      ],
      "services": [],
      "body": "Replaces primitive color tokens in the modal components with alias and component tokens."
    },
    {
      "id": "5.43.2-replace-color-tokens-in-flyout",
      "version": "5.43.2",
      "title": "Replace color tokens in flyout",
      "date": "2025-02-12",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-97",
      "tags": [
        "Design Tokens"
      ],
      "components": [
        "Spds::Modal::Flyout"
      ],
      "services": [],
      "body": "Replaces primitive color tokens in the flyout with the new alias and component tokens."
    },
    {
      "id": "5.43.1-toast-positioning-needs-correction",
      "version": "5.43.1",
      "title": "Toast positioning needs correction",
      "date": "2025-02-11",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-109",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Toast::Container",
        "Spds::Toast::Message"
      ],
      "services": [],
      "body": "Corrects toast centering, which was most noticeable on mobile screen sizes."
    },
    {
      "id": "5.43.0-allow-customization-of-alert-banner-icon",
      "version": "5.43.0",
      "title": "Allow customization of alert banner icon",
      "date": "2025-02-11",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-110",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::AlertBanner::Message"
      ],
      "services": [],
      "body": "Allows the alert banner icon to be customized."
    },
    {
      "id": "5.42.5-ghost-button-clean-up",
      "version": "5.42.5",
      "title": "Ghost button clean-up",
      "date": "2025-02-09",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-98",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "services": [],
      "body": "Updates ghost button color tokens (text, icon, and new bg-fill tokens) to clarify the button hierarchy across web and mobile."
    },
    {
      "id": "5.42.4-introduce-color-component-tokens",
      "version": "5.42.4",
      "title": "Introduce color component tokens",
      "date": "2025-02-04",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-72",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "services": [],
      "body": "Adds color component tokens to the design token library."
    },
    {
      "id": "5.42.3-introduce-color-alias-tokens",
      "version": "5.42.3",
      "title": "Introduce color alias tokens",
      "date": "2025-01-28",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-71",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "services": [],
      "body": "Adds the full set of color alias tokens (bg-surface, bg-fill, border, text, and icon) to the design token library."
    },
    {
      "id": "5.42.1-fix-full-screen-modal-resize-delay",
      "version": "5.42.1",
      "title": "Fix full screen modal resize delay",
      "date": "2025-01-22",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-94",
      "tags": [
        "DS Maintenance"
      ],
      "components": [],
      "services": [],
      "body": "Fixes a resize delay in the full screen modal's main content area by limiting the animation to the preview pane."
    },
    {
      "id": "5.42.0-introduce-search-input-component",
      "version": "5.42.0",
      "title": "Introduce search input component",
      "date": "2025-01-21",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-2",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Base",
        "Spds::Input::Checkbox",
        "Spds::Input::Dropdown",
        "Spds::Input::Group",
        "Spds::Input::KeyboardNavigable",
        "Spds::Input::Labeled",
        "Spds::Input::MenuParent",
        "Spds::Input::RadioButton",
        "Spds::Input::Search",
        "Spds::Input::Text",
        "Spds::Menu::Base",
        "Spds::Menu::Item",
        "Spds::Menu::NoResults",
        "Spds::Shared::HelperText",
        "Spds::Shared::Label",
        "Spds::Shared::MultiselectClearFilter"
      ],
      "services": [],
      "body": "Introduces a dedicated search input component with basic and multiselect menus, supported states, in-field tags, and a `Select all` option."
    },
    {
      "id": "5.41.0-move-timepicker-component-into-ember-simplepractice",
      "version": "5.41.0",
      "title": "Move timepicker component into ember-simplepractice",
      "date": "2025-01-17",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-41",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::TimePicker::DoneBox",
        "Spds::TimePicker::Trigger"
      ],
      "services": [],
      "body": "Moves the time picker component into the `ember-simplepractice` addon so it can be reused across applications."
    },
    {
      "id": "5.40.1-fix-token-css-imports",
      "version": "5.40.1",
      "title": "Fix token CSS imports",
      "date": "2025-01-16",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-87",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "services": [],
      "body": "Fixes CSS custom property duplication by importing `tokens.css` only in consuming apps rather than in the addon."
    },
    {
      "id": "5.39.6-publish-design-tokens-as-css-custom-properties",
      "version": "5.39.6",
      "title": "Publish design tokens as CSS custom properties",
      "date": "2025-01-13",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-69",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "services": [],
      "body": "Publishes the design tokens as CSS custom properties, allowing for greater flexibility in stylesheets."
    },
    {
      "id": "5.39.5-radio-button-group-hover-states-not-properly-applied",
      "version": "5.39.5",
      "title": "Radio button group hover states not properly applied",
      "date": "2025-01-09",
      "type": "fix",
      "issue": "https://linear.app/simplepractice/issue/DES-77",
      "tags": [
        "DS Maintenance"
      ],
      "components": [
        "Spds::Input::Base"
      ],
      "services": [],
      "body": "Fixes radio button group hover states not applying when the group has no selected value, by scoping the `:indeterminate` styles to checkboxes."
    },
    {
      "id": "5.39.1-update-personalization-colors",
      "version": "5.39.1",
      "title": "Update personalization colors",
      "date": "2025-01-06",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-5",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "services": [],
      "body": "Updates calendar personalization colors to solid-only, replacing the old SCSS color functions with the proper primitive and component design tokens."
    },
    {
      "id": "5.36.1-update-personalization-colors",
      "version": "5.36.1",
      "title": "Update personalization colors",
      "date": "2024-12-09",
      "type": "enhancement",
      "issue": "https://linear.app/simplepractice/issue/DES-5",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "services": [],
      "body": "Updates calendar personalization colors to solid-only, replacing the old SCSS color functions with the proper primitive and component design tokens."
    },
    {
      "id": "5.36.0-introduce-new-modal-components",
      "version": "5.36.0",
      "title": "Introduce new modal components",
      "date": "2024-12-05",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-1",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Modal::Acknowledgement",
        "Spds::Modal::Announcement",
        "Spds::Modal::Destructive",
        "Spds::Modal::Shared",
        "Spds::Modal::Standard",
        "Spds::Modal::Transactional"
      ],
      "services": [],
      "body": "Introduces dedicated modal components (announcement, transactional, acknowledgement, and danger) with optional header, footer, and body regions, plus supporting options like `closeOnClickOutside` and `onBeforeClose`."
    },
    {
      "id": "5.35.0-introduce-air-color-alias-tokens",
      "version": "5.35.0",
      "title": "Introduce air color alias tokens",
      "date": "2024-11-13",
      "type": "feature",
      "issue": "https://linear.app/simplepractice/issue/DES-4",
      "tags": [
        "Design Tokens"
      ],
      "components": [],
      "services": [],
      "body": "Adds the Air color alias tokens (icon, text, border, bg-fill, bg-surface, and bg-page) to the design token library."
    },
    {
      "id": "5.34.0-introduce-dropdown-input-component",
      "version": "5.34.0",
      "title": "Introduce dropdown input component",
      "date": "2024-11-06",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Base",
        "Spds::Input::Checkbox",
        "Spds::Input::Dropdown",
        "Spds::Input::Group"
      ],
      "services": [],
      "body": "Introduce dropdown input component."
    },
    {
      "id": "5.33.0-introduce-segmented-control-component",
      "version": "5.33.0",
      "title": "Introduce segmented control component",
      "date": "2024-09-13",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::SegmentedControl::Button",
        "Spds::Toast::Message"
      ],
      "services": [],
      "body": "Introduce segmented control component."
    },
    {
      "id": "5.31.0-introduce-checkbox-group-component",
      "version": "5.31.0",
      "title": "Introduce Checkbox Group Component",
      "date": "2024-08-29",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Base",
        "Spds::Input::Checkbox",
        "Spds::Input::Group"
      ],
      "services": [],
      "body": "Introduce Checkbox Group Component."
    },
    {
      "id": "5.29.0-introduce-text-input-component",
      "version": "5.29.0",
      "title": "Introduce text input component",
      "date": "2024-08-09",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Base",
        "Spds::Input::CharacterCounter",
        "Spds::Input::Group",
        "Spds::Input::RadioButton",
        "Spds::Input::Text"
      ],
      "services": [],
      "body": "Introduce text input component."
    },
    {
      "id": "5.28.0-introduce-tag-component",
      "version": "5.28.0",
      "title": "Introduce Tag Component",
      "date": "2024-07-22",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Indicator::Tag",
        "Spds::Indicator::TagGroup"
      ],
      "services": [],
      "body": "Introduce Tag and Tag Group components."
    },
    {
      "id": "5.27.0-introduce-radio-button-component",
      "version": "5.27.0",
      "title": "Introduce radio button component",
      "date": "2024-07-10",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Input::Base",
        "Spds::Input::Checkbox",
        "Spds::Input::Group",
        "Spds::Input::RadioButton"
      ],
      "services": [],
      "body": "Introduce radio button component."
    },
    {
      "id": "5.26.0-introduce-checkbox-component",
      "version": "5.26.0",
      "title": "Introduce Checkbox Component",
      "date": "2024-06-03",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [],
      "services": [],
      "body": "Introduce Checkbox Component."
    },
    {
      "id": "5.25.0-introduce-empty-state-component",
      "version": "5.25.0",
      "title": "Introduce Empty State Component",
      "date": "2024-05-24",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Feedback::EmptyState",
        "Spds::Feedback::EmptyState::Body"
      ],
      "services": [],
      "body": "Introduce Empty State Component."
    },
    {
      "id": "5.24.0-introduce-full-screen-modal-component",
      "version": "5.24.0",
      "title": "Introduce Full Screen Modal Component",
      "date": "2024-05-14",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Modal::FullScreen",
        "Spds::Modal::FullScreen::Body",
        "Spds::Modal::FullScreen::Footer",
        "Spds::Modal::FullScreen::Header",
        "Spds::Modal::FullScreen::Preview"
      ],
      "services": [],
      "body": "Introduce Full Screen Modal Component."
    },
    {
      "id": "5.20.0-introduce-alert-banner-component",
      "version": "5.20.0",
      "title": "Introduce Alert Banner component",
      "date": "2024-04-26",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Feedback::AlertBanner::GlobalContainer",
        "Spds::Feedback::AlertBanner::Message",
        "Spds::Feedback::Toast::Container",
        "Spds::Feedback::Toast::Message"
      ],
      "services": [
        "AlertManager"
      ],
      "body": "Introduce Alert Banner component."
    },
    {
      "id": "5.16.9-introduce-new-flyout-component",
      "version": "5.16.9",
      "title": "Introduce new flyout component",
      "date": "2024-03-29",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Modal::Flyout",
        "Spds::Modal::Flyout::Body",
        "Spds::Modal::Flyout::Footer",
        "Spds::Modal::Flyout::Header"
      ],
      "services": [],
      "body": "Introduce new flyout component."
    },
    {
      "id": "5.16.4-introduce-new-toast-component",
      "version": "5.16.4",
      "title": "Introduce new toast component",
      "date": "2024-03-15",
      "type": "feature",
      "tags": [
        "DS Component Creation"
      ],
      "components": [
        "Spds::Feedback::Toast::Container",
        "Spds::Feedback::Toast::Message"
      ],
      "services": [
        "AlertManager"
      ],
      "body": "Introduce new toast component."
    }
  ]
};
